import React, { useState, useEffect } from "react";

const PdfInitials = ({ page, inputId, value, onChange, place_holder = "Enter initials" }) => {
  const [inputValue, setInputValue] = useState('');

  // Sync internal state with parent value prop
  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    // Allow only letters and full stops, remove all other special characters
    const filteredValue = newValue.replace(/[^a-zA-Z.]/g, '');
    setInputValue(filteredValue);
    onChange(page, inputId, filteredValue);
  };

  return (
    <div className="pdf-input pdf-initial-input">
      <input
        type="text"
        placeholder={place_holder}
        value={inputValue}
        onChange={handleInputChange}
        maxLength={5}
        pattern="[a-zA-Z.]+"
        title="Please enter letters and full stops only"
        style={{ textTransform: 'uppercase' }}
      />
    </div>
  );
};

export default PdfInitials;
